import * as swcHelpers from '@swc/helpers';
import * as React from 'react';
import { LineItemCard } from '@grandvisionhq/lib-visuals';
import { useIntl } from '@grandvisionhq/state';
import { getLineItemBody } from '../utils/get-product-body.js';

const LineItemsContainer = ({ lineItems  })=>{
    const { getLabel , currency  } = useIntl();
    const labels = {
        monthlySubscription: getLabel('products.monthlySubscription'),
        quantity: getLabel('cart.item.quantity'),
        unitMilli: getLabel('products.unit.metric.liter.milli.abbr'),
        leftEye: getLabel('products.contactLenses.leftEye'),
        rightEye: getLabel('products.contactLenses.rightEye'),
        quotation: getLabel('products.contactLenses.quotationMiniCart'),
        power: getLabel('products.contactLenses.prescription.power')
    };
    return /*#__PURE__*/ React.createElement(React.Fragment, null, lineItems.map((lineItem, i)=>{
        const { quantity , subtitle  } = getLineItemBody({
            lineItem,
            labels
        });
        const baseProps = {
            currency,
            discountPrice: lineItem.discountPrice ? lineItem.price : 0,
            imagePath: lineItem.imageUrl,
            lineItemId: lineItem.lineItemId,
            price: lineItem.originalPrice || lineItem.price,
            quantity,
            subtitle,
            title: lineItem.title,
            compactCard: false,
            mini: true,
            quoteConfig: (lineItem === null || lineItem === void 0 ? void 0 : lineItem.quoteConfig) || undefined,
            additionalInfo: lineItem.additionalInfo
        };
        return /*#__PURE__*/ React.createElement(LineItemCard, swcHelpers.extends({
            key: `${lineItem.lineItemId}+${i}`
        }, baseProps));
    }));
};

export { LineItemsContainer };
//# sourceMappingURL=LineItemsContainer.js.map
